import { render } from "./WarehouseSelect.vue?vue&type=template&id=20320ea6&scoped=true"
import script from "./WarehouseSelect.vue?vue&type=script&lang=js"
export * from "./WarehouseSelect.vue?vue&type=script&lang=js"

import "./WarehouseSelect.vue?vue&type=style&index=0&id=20320ea6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20320ea6"],['__file',"src/components/h5/product/WarehouseSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20320ea6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20320ea6', __exports__)) {
    api.reload('20320ea6', __exports__)
  }
  
  module.hot.accept("./WarehouseSelect.vue?vue&type=template&id=20320ea6&scoped=true", () => {
    api.rerender('20320ea6', render)
  })

}


export default __exports__